import React, { useState, useCallback, useEffect, useMemo } from 'react';

export default function StepThree ({
	marqueeOptions,
	quoteDetails,
	setStepState,
	setQuoteDetails,
	handleStartAgain
}) {
	const [choosenOptions, setChoosenOptions] = useState([]);
	const [modalContent, setModalContent] = useState(null);

	const availableOptions = useMemo(() => {
		const quoteOptions = quoteDetails.marquee.options;

		if (quoteOptions.length > 0) {
			const { options } = marqueeOptions;

			return {
				...marqueeOptions,
				options: quoteOptions.concat(options)
			};
		}

		return marqueeOptions;
	}, [marqueeOptions, quoteDetails.marquee.options]);

	const handleNextClick = useCallback(() => {
		setQuoteDetails({
			marqueeOptions: choosenOptions
		}, setStepState(4));
	}, [choosenOptions, setQuoteDetails, setStepState]);

	const handleAddRemoveOption = useCallback(() => {
		const optionInState = _arrayHasKey(choosenOptions, 'optionName', modalContent?.optionName),
			option = document.querySelector(`.marquee-options__card[data-option="${modalContent?.optionName}"]`),
			optionButton = document.querySelector(`.marquee-options__card[data-option="${modalContent?.optionName}"] button`);

		if (!modalContent) {
			return;
		}

		if (optionInState.match) {
			setChoosenOptions(prevChoosenOptions => ([...prevChoosenOptions.filter(option => option !== optionInState.el)]));

			option.dataset.selected = false;
			optionButton.innerHTML = 'select'
		} else {
			setChoosenOptions(prevChoosenOptions => ([
				...prevChoosenOptions,
				{
					optionName: modalContent.optionName,
					id: modalContent.id,
					value: modalContent.value,
					quantity: 1
				}

			]));

			handleOptionUpdate(modalContent.optionName);
		}
	}, [choosenOptions, handleOptionUpdate, modalContent]);

	const handleRemoveOption = useCallback(() => {
		const optionName = modalContent.optionName;
		const choosenOptionsCopy = [...choosenOptions];

		choosenOptionsCopy.forEach((option, i) => {
			if (option.optionName === optionName) {
				delete choosenOptionsCopy[i]

				choosenOptionsCopy.splice(i, 0);

				const option = document.querySelector(`.marquee-options__card[data-option="${optionName}"]`),
					optionButton = option.querySelector('button');

				option.dataset.selected = false;
				optionButton.innerHTML = 'select'
			}
		});

		setChoosenOptions([...choosenOptionsCopy.filter((el) => el != null)]);
		handleModalClose();
	}, [choosenOptions, handleModalClose, modalContent]);

	const handleAddOptionQty = useCallback(() => {
		if (!modalContent?.qty) {
			handleAddRemoveOption();
		} else {
			const qty = document.querySelector('.quantity-modal input').value,
				value = (modalContent.value * qty),
				optionName = modalContent.optionName,
				id = modalContent.id,
				optionInState = _arrayHasKey(choosenOptions, 'optionName', optionName);

			if (qty >= 1) {
				let optionsClone = choosenOptions;

				if (optionInState.match) {
					optionsClone = [...optionsClone.filter(option => option !== optionInState.el)];
				}

				setChoosenOptions([
					...optionsClone,
					{
						optionName: optionName,
						id: id,
						value: value,
						quantity: qty
					}
				]);

				handleOptionUpdate(optionName, qty, value);
			} else {
				handleRemoveOption();
			}
		}
	}, [modalContent, handleAddRemoveOption, choosenOptions, handleOptionUpdate, handleRemoveOption]);

	const handleOptionUpdate = useCallback((optionName, qty, value) => {
		const option = document.querySelector(`.marquee-options__card[data-option="${optionName}"]`),
			optionButton = option.querySelector('button');

		option.dataset.selected = true;
		optionButton.innerHTML = qty ? `${qty} selected | £${value}` : 'selected';
		handleModalClose();
	}, [handleModalClose]);

	const handleOptionClick = (e) => {
		e.preventDefault();
		e.stopPropagation();

		let imgClicked = false,
			buttonClicked = false;

		if (e.currentTarget.nodeName === 'BUTTON') {
			buttonClicked = true;
		} else {
			imgClicked = true;
		}

		if (buttonClicked && e.currentTarget.parentNode.parentNode.dataset.optionQty === "false") {
			handleModalOpen(e.currentTarget.parentNode.parentNode.dataset, true, true);
		} else if (buttonClicked && e.currentTarget.parentNode.parentNode.dataset.optionQty === "true") {
			handleModalOpen(e.currentTarget.parentNode.parentNode.dataset);
		} else if (imgClicked && e.currentTarget.dataset.optionQty === "false") {
			handleModalOpen(e.currentTarget.dataset, true);
		} else if (imgClicked && e.currentTarget.dataset.optionQty === "true") {
			handleModalOpen(e.currentTarget.dataset);
		}
	}

	const handleModalOpen = useCallback((data, singleItem, addToQuote) => {
		const container = document.querySelector('.step-three__marquee-options'),
			modal = document.querySelector('.quantity-modal'),
			addBtn = modal.querySelector('.quantity-modal__add-btn'),
			input = modal.querySelector('input'),
			modalContentObj = {
				optionName: data.option,
				id: data.id,
				image: availableOptions.options[data.index].option_image,
				value: availableOptions.options[data.index].option_value,
				qty: data.optionQty === "true" ? true : false,
				vimeoID: availableOptions.options[data.index].vimeo_id,
				addToQuote
			};

		addBtn.innerHTML = 'Add option';

		setModalContent(modalContentObj);

		if (!addToQuote) {
			if (singleItem) {
				input.parentNode.style.display = 'none';
			} else {
				input.parentNode.style.display = 'inline-block';
			}

			if (choosenOptions.length === 0) {
				addBtn.style.display = 'block';
			}

			choosenOptions.forEach((option) => {
				if (option.optionName === data.option) {
					if (singleItem) {
						addBtn.style.display = 'none';
					} else {
						addBtn.style.display = 'block';
						addBtn.innerHTML = 'Update option';
						input.value = option.quantity;
					}
				}
			});

			modal.classList.add('quantity-modal--open');

			setTimeout(() => {
				modal.classList.add('quantity-modal--visible');

				setTimeout(() => {
					container.classList.add('modal--open');
				}, 500);
			}, 100);
		}
	}, [availableOptions, choosenOptions]);

	const handleModalClose = useCallback(() => {
		const container = document.querySelector('.step-three__marquee-options'),
			modal = document.querySelector('.quantity-modal'),
			input = modal.querySelector('input');

		if (modalContent?.vimeoID) {
			const iframe = modal.querySelector('iframe'),
				iframeSrc = iframe.src;

			iframe.src = iframeSrc;
		}

		container.classList.remove('modal--open');
		modal.classList.remove('quantity-modal--visible');
		setTimeout(() => {
			modal.classList.remove('quantity-modal--open');
		}, 500);
		input.value = '';
	}, [modalContent]);

	useEffect(() => {
		if (modalContent && modalContent.addToQuote) {
			handleAddRemoveOption();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalContent])

	return (
		<div className="step-three">
			{availableOptions.heading.length > 0 ?
				<RenderStepThreeMarkup
					availableOptions={availableOptions}
					modalContent={modalContent}
					handleOptionClick={handleOptionClick}
					handleAddOptionQty={handleAddOptionQty}
					handleRemoveOption={handleRemoveOption}
					handleModalClose={handleModalClose}
					handleNextClick={handleNextClick}
					handleStartAgain={handleStartAgain}
				/>

				:

				<div className="loader">
					<div className="loader-inner"></div>
					<div className="loader-triangle"></div>
				</div>
			}
		</div>
	)
}

const RenderOptions = ({ options, handleOptionClick }) => {
	return options ? options?.map((option, index) => {
		const { option_name, option_value, option_image, option_description, quantity_field, id } = option;

		return (
			<div
				key={`${id}_${option_name}`}
				className="marquee-options__card"
				data-index={index}
				data-id={id}
				data-option-selected={false}
				data-option={option_name}
				data-option-value={option_value}
				data-option-qty={quantity_field ? true : false}
				onClick={handleOptionClick}
			>
				<div className="marquee-options__card-left">
					<img src={option_image} alt={option_name} />
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z" /></svg>
				</div>
				<div className="marquee-options__card-right">
					<h4>{option_name}</h4>
					<div className="marquee-options__card-rich-text" dangerouslySetInnerHTML={{ __html: option_description }} />
					<p className="marquee-options__card-price">{`£${option_value}`}</p>
					<button
						onClick={handleOptionClick}
						data-index={index}
						data-id={id}
						data-option-selected={false}
						data-option={option_name}
						data-option-value={option_value}
						data-option-qty={quantity_field ? true : false}
					>
						select
					</button>
				</div>
			</div>
		)
	}) : 'NO OPTIONS'
}

const RenderStepThreeMarkup = ({ availableOptions, modalContent, handleOptionClick, handleAddOptionQty, handleRemoveOption, handleModalClose, handleNextClick, handleStartAgain }) => {

	return (
		<div className="step-three__section">
			<div className="step-three__info-container">
				<h4>{availableOptions.heading}</h4>
				<p>{availableOptions.description}</p>
			</div>

			<div className="step-three__marquee-options">
				{<RenderOptions options={availableOptions.options} handleOptionClick={handleOptionClick} />}

				<div className="quantity-modal">
					<div>
						{modalContent ? (
							<>
								<h4>{modalContent.optionName}</h4>

								{modalContent.vimeoID ?
									<iframe
										src={`https://player.vimeo.com/video/${modalContent.vimeoID}`}
										frameBorder="0" title={modalContent.optionName}
										allowFullScreen={true}
									></iframe>

									:

									<img src={modalContent.image} alt={modalContent.optionName} />
								}
							</>
						) : null}

						<label>
							<p>Quantity</p>
							<input
								className="quantity-modal__input"
								min="1"
								max="100"
								name='partyGuests'
								step="1"
								type="number"
								pattern="[0-9]*"
							/>
						</label>

						<button onClick={handleAddOptionQty} className="quantity-modal__add-btn">Add Option</button>
						<button onClick={handleRemoveOption} className="quantity-modal__remove-btn">Remove Option</button>
						<button onClick={handleModalClose} className="quantity-modal__close-btn">Close</button>
					</div>
				</div>

			</div>
			<button onClick={handleNextClick} className="step-two__next-btn">Confirm options</button>
			<button onClick={handleStartAgain} className="quote-calculator__back-btn">Start Again</button>
		</div>
	);
}

const _arrayHasKey = (arr, key, value) => {
	const obj = {};

	arr.forEach((el) => {
		if (el[key] === value) {
			return obj.match = true, obj.el = el;
		} else {
			return obj.match = false;
		}
	});

	return obj;
}
